var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "focus-trap",
    {
      ref: "focustrap",
      attrs: {
        active: _vm.showMenu,
        "allow-outside-click": true,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.menuNeeded,
              expression: "menuNeeded",
            },
          ],
          attrs: {
            role: "navigation",
            id: "responsive-navigation-container",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "responsive-navigation-header",
            },
            [
              _c(
                "transition",
                {
                  attrs: {
                    name: "slide",
                    appear: "",
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "styleless",
                      attrs: {
                        id: "responsive-navigation-button",
                        "aria-label": _vm.showMenu
                          ? _vm.$gettext("Navigation schließen")
                          : _vm.$gettext("Navigation öffnen"),
                        "aria-expanded": _vm.showMenu,
                        "aria-controls": "responsive-navigation-items",
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          return _vm.toggleMenu.apply(null, arguments)
                        },
                        keydown: [
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "space", 32, $event.key, [
                                " ",
                                "Spacebar",
                              ])
                            )
                              return null
                            $event.preventDefault()
                            return _vm.toggleMenu.apply(null, arguments)
                          },
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                            return _vm.toggleMenu.apply(null, arguments)
                          },
                        ],
                      },
                    },
                    [
                      _c("studip-icon", {
                        class: _vm.showMenu ? "menu-open" : "menu-closed",
                        attrs: {
                          shape: "hamburger",
                          role: "info_alt",
                          alt: _vm.showMenu
                            ? _vm.$gettext("Navigation schließen")
                            : _vm.$gettext("Navigation öffnen"),
                          size: _vm.iconSize,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: {
                name: "appear",
                appear: "",
              },
            },
            [
              _c(
                "nav",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showMenu,
                      expression: "showMenu",
                    },
                  ],
                  ref: "navigation",
                  staticClass: "responsive",
                  attrs: {
                    id: "responsive-navigation-items",
                  },
                },
                [
                  _vm.me.username !== "nobody"
                    ? _c(
                        "header",
                        [
                          !_vm.avatarMenuOpen
                            ? [
                                _c(
                                  "section",
                                  {
                                    staticClass: "profile-info",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "profile-pic",
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.me.avatar,
                                            title: _vm.$gettext(
                                              "Profilnavigation öffnen"
                                            ),
                                            "aria-label": _vm.$gettext(
                                              "Profilnavigation öffnen"
                                            ),
                                          },
                                          on: {
                                            click: function click($event) {
                                              $event.preventDefault()
                                              return _vm.toggleAvatarMenu.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "profile-data",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(_vm._s(_vm.me.fullname)),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(_vm.me.email) +
                                              " (" +
                                              _vm._s(_vm.me.perm) +
                                              ")"
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "section",
                                  {
                                    staticClass: "open-avatarmenu",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        ref: "openAvatarmenu",
                                        staticClass: "styleless",
                                        attrs: {
                                          title: _vm.$gettext(
                                            "Profilnavigation öffnen"
                                          ),
                                          "aria-label": _vm.$gettext(
                                            "Profilnavigation öffnen"
                                          ),
                                        },
                                        on: {
                                          keydown: [
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              )
                                                return null
                                              $event.preventDefault()
                                              return _vm.toggleAvatarMenu.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "space",
                                                  32,
                                                  $event.key,
                                                  [" ", "Spacebar"]
                                                )
                                              )
                                                return null
                                              $event.preventDefault()
                                              return _vm.toggleAvatarMenu.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          ],
                                          click: function click($event) {
                                            $event.preventDefault()
                                            return _vm.toggleAvatarMenu.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("studip-icon", {
                                          attrs: {
                                            shape: "arr_1right",
                                            role: "info_alt",
                                            size: _vm.iconSize,
                                            alt: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "focus-trap",
                                  {
                                    attrs: {
                                      active: true,
                                      "return-focus-on-deactivate": true,
                                      "click-outside-deactivates": true,
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "close-avatarmenu",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              ref: "closeAvatarmenu",
                                              staticClass: "styleless",
                                              attrs: {
                                                title: _vm.$gettext(
                                                  "Profilnavigation schließen"
                                                ),
                                                "aria-label": _vm.$gettext(
                                                  "Profilnavigation schließen"
                                                ),
                                              },
                                              on: {
                                                keydown: [
                                                  function ($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    )
                                                      return null
                                                    $event.preventDefault()
                                                    return _vm.toggleAvatarMenu.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                  function ($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "space",
                                                        32,
                                                        $event.key,
                                                        [" ", "Spacebar"]
                                                      )
                                                    )
                                                      return null
                                                    $event.preventDefault()
                                                    return _vm.toggleAvatarMenu.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                ],
                                                click: _vm.toggleAvatarMenu,
                                              },
                                            },
                                            [
                                              _c("studip-icon", {
                                                attrs: {
                                                  shape: "arr_1left",
                                                  role: "info_alt",
                                                  size: _vm.iconSize,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "avatar-navigation",
                                        },
                                        _vm._l(
                                          _vm.avatarNavigation.children,
                                          function (item, index) {
                                            return _c("navigation-item", {
                                              key: index,
                                              attrs: {
                                                item: item,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "main-navigation",
                    },
                    [
                      _vm.currentParent != null
                        ? _c(
                            "li",
                            {
                              staticClass: "navigation-item navigation-up",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "navigation-title",
                                  attrs: {
                                    title: _vm.$gettext("Zum Start"),
                                    "aria-label": _vm.$gettext("Zum Start"),
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "styleless",
                                      on: {
                                        click: function click($event) {
                                          return _vm.moveTo("/")
                                        },
                                        keydown: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                            return _vm.moveTo("/")
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "space",
                                                32,
                                                $event.key,
                                                [" ", "Spacebar"]
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                            return _vm.moveTo("/")
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "navigation-icon",
                                        },
                                        [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: "arr_2up",
                                              role: "info_alt",
                                              size: _vm.iconSize - 4,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "navigation-text",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.$gettext("Start")) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentParent != null
                        ? _c(
                            "li",
                            {
                              staticClass: "navigation-item navigation-current",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "navigation-title",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "styleless",
                                      attrs: {
                                        title: _vm.$gettext("Eine Ebene höher"),
                                        "aria-label":
                                          _vm.$gettext("Eine Ebene höher"),
                                      },
                                      on: {
                                        click: function click($event) {
                                          return _vm.moveTo(
                                            _vm.currentParent.path
                                          )
                                        },
                                        keydown: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                            return _vm.moveTo(
                                              _vm.currentParent.path
                                            )
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "space",
                                                32,
                                                $event.key,
                                                [" ", "Spacebar"]
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                            return _vm.moveTo(
                                              _vm.currentParent.path
                                            )
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "navigation-icon",
                                        },
                                        [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: "arr_1left",
                                              role: "info_alt",
                                              size: _vm.iconSize - 4,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "navigation-text",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$gettext("Eine Ebene höher")
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(
                        _vm.currentNavigation.children,
                        function (item, index) {
                          return _c("navigation-item", {
                            key: index,
                            attrs: {
                              item: item,
                              active: item.active,
                            },
                          })
                        }
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          (_vm.isResponsive || _vm.isFullscreen) && !_vm.isFocusMode
            ? _c("responsive-content-bar", {
                ref: "contentbar",
                attrs: {
                  "has-sidebar": _vm.hasSidebar,
                  title: _vm.contentbarTitle,
                  "aria-label": _vm.contentbarTitle,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          (_vm.isResponsive || _vm.isFullscreen) && _vm.hasSkiplinks
            ? _c("responsive-skip-links", {
                attrs: {
                  links: _vm.skipLinks,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }